import React from "react";
import { graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import parse from "html-react-parser";

import NewsButton from "../components/news_button";

import Layout from "../components/layout";
import SEO from "../components/seo";

// Patterns
import PatternFirst from "../images/pattern_01.png";

// import ArrowForward from "../images/icons/arrow_forward.svg";
// import LoadMore from "../images/icons/load_more.svg";

export default function Home({
  data: { page, posts, forms, header, footer, socials, copyright, user, cookies },
}) {
  const pageContent = page.nodes[0].pageNews;
  const wpContent = page.nodes[0];

  forms = forms.nodes[0]

  return (
    <Layout
      footer={footer.nodes}
      header={header.nodes}
      forms={forms}
      user={user.nodes}
      cookies={cookies.nodes}
      copyright={copyright.nodes}
      socials={socials.nodes[0].socialNetworks}
      locale={page.nodes[0].locale.locale}
      uri={page.nodes[0].uri}
    >
      <SEO title={page.nodes[0].seo.title} description={page.nodes[0].seo.metaDesc} />
      <header className="head">
        <nav className="breadcrumb" aria-label="Breadcrumb">
          <ol className="breadcrumb__list">
            {wpContent.seo.breadcrumbs.map((value, i) => (
              <li key={i} className="breadcrumb__item">
                <Link
                  activeClassName="breadcrumb__link__active"
                  className="breadcrumb__link"
                  to={value.url}
                  dangerouslySetInnerHTML={{
                    __html: value.text,
                  }}
                ></Link>
              </li>
            ))}
          </ol>
        </nav>
        <h1>{parse(pageContent.pageTitle)}</h1>
        <p>{parse(pageContent.pageSubtitle)}</p>
        <div className="pattern">
          <img src={PatternFirst} alt="Pattern" />
        </div>
      </header>
      <div className="news">
        {posts.edges.map(({ node }, i) => (
          <Link key={i} to={node.uri} className="news__item">
            {node.articlesContent?.articleImg?.localFile?.childImageSharp
              ?.gatsbyImageData && (
              <div className="news__image">
                <GatsbyImage
                  image={
                    node.articlesContent?.articleImg?.localFile?.childImageSharp
                      ?.gatsbyImageData
                  }
                  alt={node.articlesContent?.articleImg?.altText || ``}
                />
              </div>
            )}
            <span className="date">{node.date}</span>
            <strong className="news__title">{node.title}</strong>
            {!!node.articlesContent.articleExcerpt && (
              <div
                dangerouslySetInnerHTML={{
                  __html: node.articlesContent.articleExcerpt,
                }}
              ></div>
            )}
            <NewsButton />
          </Link>
        ))}
      </div>
      {/* <Link to="/news/" className="loadMore">
        <img src={LoadMore} alt="" /> більше новин
      </Link> */}
    </Layout>
  );
}

export const query = graphql`
  {
    copyright: allWpRepeatableBlocks(
      filter: {slug: {eq: "copyrights"}}
    ) {
      nodes {
        slug
        title
        blockCopyrights {
          copyrightTextAfter
          copyrightTextBefore
          copyrightTextMiddle
          userAgreement {
            linkText
          }
          cookiesPolicy {
            linkText
          }
        }
        uri
        locale {
          locale
        }
      }
    }
    user: allWpRepeatableBlocks(filter: {slug: {eq: "ugoda-korystuvacha"}}) {
      nodes {
        slug
        title
        uri
        locale {
          locale
        }
        blockUserAgreement {
          agreementBlockId
          userAgreementText
          userAgreementButtonText
          userAgreementTitle
        }
      }
    }
    cookies: allWpRepeatableBlocks(filter: {slug: {eq: "polityka-cookies"}}) {
      nodes {
        slug
        title
        uri
        locale {
          locale
        }
        blockUserAgreement {
          agreementBlockId
          userAgreementText
          userAgreementButtonText
          userAgreementTitle
        }
      }
    }
    page: allWpPage(
      filter: { slug: { eq: "news" }, locale: { locale: { eq: "uk" } } }
    ) {
      nodes {
        pageNews {
          pageSubtitle
          pageTitle
        }
        slug
        locale {
          locale
        }
        seo {
          title
          metaDesc
          breadcrumbs {
            text
            url
          }
        }
        uri
      }
    }
    posts: allWpPost(
      filter: {locale: {locale: {eq: "uk"}}}
      sort: {fields: date, order: DESC}
    ) {
      edges {
        node {
          slug
          uri
          title
          date(formatString: "DD.MM.YYYY")
          articlesContent {
            articleContent
            articleExcerpt
            articleImg {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(quality: 100, placeholder: DOMINANT_COLOR)
                }
              }
            }
          }
          locale {
            locale
          }
        }
      }
    }
    footer: allWpRepeatableBlocks(filter: { slug: { eq: "footer" } }) {
      nodes {
        mainFooter {
          copyrightText
          footerLogo
          orderButtonIcon
          orderButtonText
          centrColumnItems {
            item
            name
          }
          leftColumnItems {
            name
            item
          }
          rightColumnItems {
            item
            name
          }
        }
        slug
        title
        locale {
          locale
        }
      }
    }
    forms: allWpRepeatableBlocks(
      filter: { locale: { locale: { eq: "uk" } }, slug: { eq: "formy" } }
    ) {
      nodes {
        slug
        title
        formSettings {
          contactFormCommentPlaceholder
          contactFormEmailPlaceholder
          contactFormSendButton
          contactFormTitle
          fieldGroupName
          modalCallbackButtonText
          modalCallbackTitle
          modalThanksButtonText
          modalThanksText
          modalThanksTitle
          modalViewingButtonText
          modalViewingFormTitle
          viewingFormDatetime
          viewingFormSendButton
          viewingFormTitle
          viewingFormUsername
        }
        locale {
          locale
        }
      }
    }
    header: allWpRepeatableBlocks(filter: { slug: { eq: "header" } }) {
      nodes {
        slug
        title
        locale {
          locale
        }
        mainHeader {
          headerLogo
          headerSubmenu {
            dropdownBtnIcon
            dropdownPages {
              pageTitle
              pageLink
            }
          }
          menuCallbackBtn {
            icon
            text
          }
          menuOrderHouseBtn {
            icon
            link
            text
          }
          headerMenuFix {
            pageLink
            pageTitle
          }
          headerMessengerMenu {
            messengerList {
              icon
              link
            }
            dropdownBtnIcon
          }
        }
      }
    }
    socials: allWpRepeatableBlocks(
      filter: {
        locale: { locale: { eq: "uk" } }
        slug: { eq: "soczialni-merezhi" }
      }
    ) {
      nodes {
        slug
        title
        locale {
          locale
        }
        socialNetworks {
          socialNetworks {
            icon
            link
            title
          }
        }
      }
    }
  }
`;
